import React, { Component } from 'react';
import { connect } from 'react-redux'
import Questions from './Questions';
import { fetchPropertyCalcIfNeeded, updatePropertyInputBulk } from '../PropertyActions'
import { Alert, Card, CardBody } from 'reactstrap';
import ResultsTable from './ResultsTable';
import CapitalTable from './CapitalTable';
import { debounce } from 'lodash';
import { NestEggPanel } from './NestEggPanel';
import { ReturnProfitPanel } from './ReturnProfitPanel';
import { PurchasePropertyPanel } from './PurchasePropertyPanel';
import ShareUrl from './ShareUrl';
import Loading from '../Loading';
import { fromQS } from '../QSMapper';
import ReactGA from 'react-ga';

class PropertyCalculator extends Component {
    displayName = PropertyCalculator.name
    
    componentDidMount() {
        if (this.props.location.search && !this.props.location.search.includes('embed')) {
            let qsVals = fromQS(this.props.location.search);

            // Jump directly to results page
            qsVals['showReport'] =  true;

            if (qsVals) {
                this.props.dispatch(updatePropertyInputBulk(qsVals));
            }

            // Clear QS from route:
            this.props.history.push(window.location.pathname);

            // Log to analytics
            ReactGA.event({
                category: 'Sharing',
                action: 'Visit from shared URL'
            });

        }

        this.props.dispatch(fetchPropertyCalcIfNeeded());

    }

    /*
    debouncedCalc = debounce((e) => {
        this.props.dispatch(fetchPropertyCalcIfNeeded());
    }, 1000)
    
    componentDidUpdate(prevProps) {
        this.debouncedCalc();
    }*/


    render() {
        return (
            this.props.showReport ?
                <React.Fragment>
                    <Loading isFetching={this.props.isFetching}/>
                    <div className="report-container">
                        {this.props.over150k &&
                            <Alert color="danger">
                                <span data-testid="150kIncomeNotSupproted">Income over £150k not currently supported.</span>
                            </Alert>
                        }
                        {this.props.goal === "nextProperty" && <PurchasePropertyPanel
                            profitGoal={this.props.profitGoal}
                            additionalAnnualInvestment={this.props.additionalAnnualInvestment}
                            incomePersonal={!this.props.over150k ? this.props.taxProjectionPersonal.netProfitReturned : 0}
                            incomeSPV={(!this.props.over150k ? (this.props.taxProjectionSPV.grossProfit - this.props.taxProjectionSPV.corporationTax) : 0)}
                        />}

                        {this.props.goal === "retain" &&
                            <NestEggPanel
                            incomeNet={this.props.incomeNet}
                            growthProfitTotal={this.props.growthProfitTotal}
                            growthCapitalTotal={this.props.growthCapitalTotal}
                            growthCapitalByYear={this.props.growthCapitalByYear}
                            roi={this.props.roi}
                        />
                    }

                        {this.props.goal === "income" &&
                            <ReturnProfitPanel
                            roi={this.props.roi}
                            incomeNet={this.props.incomeNet}
                            over150k={this.props.over150k}
                            taxProjectionSPV={this.props.taxProjectionSPV}
                            taxProjectionPersonal={this.props.taxProjectionPersonal}
                        />
                        }
                        <ResultsTable />
                        <ShareUrl />
                    </div>
                </React.Fragment>
                /*<CapitalTable />*/
                :
                <Questions />
                
        );
    }
}



const mapStateToProps = state => {
    return state.property;
};


export default connect(mapStateToProps)(PropertyCalculator);


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/PropertyCalculator.jsx